import React from "react";
import GoogleAds from "./GoogleAds";

const MainScreenComponent = (props) => {
  const { handleNewChat } = props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <GoogleAds />
    </div>
  );
};

export default MainScreenComponent;
